import { ReactElement, useCallback } from 'react';
import { Box } from '@mui/material';

import successImage from 'modules/common/assets/stake-success.png';
import { SuccessDialogContent } from 'modules/common/components/SuccessDialogContent';
import { DEFAULT_DECIMAL_PLACES } from 'modules/common/const';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { Dialog } from 'modules/dialogs/components/Dialog';
import { useGlobalTranslation } from 'modules/i18n';
import { IModalSuccessState } from 'modules/liquidStaking/types';

import { translation } from './translation';

interface IProps {
  onClose?: () => void;
}

export function StakeSuccessDialog({ onClose }: IProps): ReactElement {
  const { t, keys } = useGlobalTranslation(translation);

  const {
    isOpened,
    onClose: onCloseModal,
    context,
  } = useDialog<IModalSuccessState>(KnownDialogs.tabStakeSuccess);

  const { inAmount, outAmount, txHash } = context;
  const inAmountStr = inAmount
    ?.decimalPlaces(DEFAULT_DECIMAL_PLACES)
    .toFormat();
  const outAmountStr = outAmount
    ?.decimalPlaces(DEFAULT_DECIMAL_PLACES)
    .toFormat();

  const handleClose = useCallback(() => {
    onClose?.();
    onCloseModal();
  }, [onClose, onCloseModal]);

  return (
    <Dialog open={isOpened} onClose={handleClose}>
      <Box
        sx={theme => ({
          display: 'flex',
          flexDirection: 'column',
          minHeight: 487,

          [theme.breakpoints.down('md')]: { minHeight: 475 },
        })}
      >
        <SuccessDialogContent
          buttonLabel={t(keys.buttonText)}
          description={t(
            keys.doneDescription,
            {
              inAmount: inAmountStr,
              outAmount: outAmountStr,
              mainToken: t(keys.tokens.main),
              stakeToken: t(keys.tokens.stakeToken),
            },
            true,
          )}
          image={successImage}
          title={t(keys.done)}
          txHash={txHash}
          onClose={handleClose}
        />
      </Box>
    </Dialog>
  );
}
